<div class="validation-element">
  <ng-container
    *ngIf="((errorText || externalErrorText) && formModel.invalid && (formModel.dirty || formModel.formDirective?.submitted)) || externalWarningText; else requiredElement">
    <i class="icon-nottoday validation-element_warning"
       [class.validation-element_warning-warning]="externalWarningText"
       pTooltip="{{showErrorText ? ((errorText || externalErrorText || externalWarningText) | translate) : ''}}"
       tooltipPosition="left"
       [tooltipStyleClass]="externalWarningText ? 'validation-element_warning_tooltip validation-element_warning-warning_tooltip' : 'validation-element_warning_tooltip'"
       aria-live="assertive"
    ></i>
  </ng-container>
  <ng-template #requiredElement>
    <div *ngIf="showRequiredElementFlag"
         class="validation-element_required"
         [class.invalid]="formModel.invalid && (formModel.dirty || formModel.formDirective?.submitted)"
    ></div>
  </ng-template>
</div>
